import type { IconData } from '@stacksjs/iconify-core'

export const arrowCursor1Flat: IconData = {
  "body": "<path fill=\"#8fbffa\" d=\"M7.801 1.511C4.065.8.8 4.065 1.511 7.801c2.972 15.594 6.573 25.959 8.622 31.093c1.162 2.91 4.552 4.052 7.234 2.417a78 78 0 0 0 6.394-4.349l5.006 6.547c1.916 2.506 5.472 3.685 8.384 1.624c1.249-.885 2.716-2.079 4.31-3.673s2.788-3.06 3.672-4.31c2.061-2.912.882-6.467-1.623-8.383l-6.547-5.007a78 78 0 0 0 4.348-6.393c1.636-2.683.493-6.073-2.417-7.234c-5.134-2.05-15.498-5.65-31.093-8.622\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default arrowCursor1Flat
